import React from 'react';
import { useParams } from 'react-router-dom';
import useGetCollectionIdByHandleSWR from '../../../../hooks/collection/useGetCollectionIdByHandleSWR';
import useShopifyCollectionNameSWR from '../../../../hooks/shopify/useShopifyCollectionNameSWR';
import { Collection } from '../../../collections/Collection';

export const Collections: React.FC = () => {
    const { handle } = useParams();
    const { collection, isLoading } = useShopifyCollectionNameSWR(handle);
    const { collectionId, isCollectionIdLoading, isCollectionIdError } =
        useGetCollectionIdByHandleSWR(handle);

    return (
        <>
            {!isCollectionIdLoading && !isCollectionIdError && (
                <Collection
                    handle={handle}
                    collection={collection}
                    collectionId={collectionId}
                    isCollectionIdLoading={isCollectionIdLoading}
                    isLoading={isLoading}
                />
            )}
        </>
    );
};
